import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MockConfig } from './model/mock.model';
import { MockService } from './services/mock.service';

import { MOCK_CONFIG } from './tokens';

export const mockInterceptor: HttpInterceptorFn = (request, next) => {
  const mockConfig: MockConfig = inject(MOCK_CONFIG);
  const mockService: MockService = inject(MockService);

  // if dev, set mock data in header
  if (mockConfig.isDevMode) {
    request = mockService.attachMockArgs(request);
  }

  return next(request);
};
